import React, { useState, useEffect, useRef } from "react";
import classes from "./Journal.module.css";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { BASE_URL } from '../../../../Components/Styles/API/API';
import Swal from "sweetalert2";
import crop from "../../../../Assets/repoort.png";
import verified from "../../../../Assets/verified.svg";
import RotatingLogo from '../../../../Assets/rotating-logo.png'
import { Button, Modal, Form, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import Select from "react-select";


function JournalModal({ isOpen, onClose }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false }
  ]);
  const [reference, setReference] = useState("");
  const [loadingRef, setLoadingRef] = useState(false);
  const [loading, setLoading] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [incomeAccount, setIncomeAccount] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [balances, setBalances] = useState([]);
  const [createLoading, setCreateLoading] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [bearer, setBearer] = useState('');
  const [permits, setPermits] = useState([]);
  const [user, setUser] = useState('');
  const [company, setCompany] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [currentMonth, setCurrentMonth] = useState('');
  const [provinceID, setProvinceID] = useState('');
  const [admin, setAdmin] = useState("");
  const [continent, setContinent] = useState('');
  const [validity, setValidity] = useState('');
  const [balanceLoading, setBalanceLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

      const readData = async () => {
        try {
          const value = localStorage.getItem('userToken');
          const value1 = localStorage.getItem('tobi');
          // const value2 = localStorage.getItem('permissions');
          const value3 = localStorage.getItem('admin');
          const value7 = localStorage.getItem('companyName');
          const value8 = localStorage.getItem('validity');
          const permitsss = localStorage.getItem('permissions');
          const continentName = localStorage.getItem('continent');
          const regionName = localStorage.getItem('region');
          const provinceName = localStorage.getItem('province');
          const current = localStorage.getItem('currentMonth');
          const provinceId = localStorage.getItem('provinceID');
          
    
    
          if (value !== null) {
            setBearer(value);
          }
          if (permitsss !== null) {
            const parsedPermits = JSON.parse(permitsss);
            const permitNames = parsedPermits.map(permit => permit.name);
            setPermits(permitNames);
            // console.log(permitNames);
          }
          if (value1 !== null) {
            setUser(value1);
          }
          if (continentName !== null) {
            setContinent(continentName);
          }
          if (regionName !== null) {
            setRegion(regionName);
          }
          if (provinceName !== null) {
            setProvince(provinceName);
          }
    
          if (value8 !== null) {
            setValidity(value8);
          }
          if (current !== null) {
            console.log(current);
            const date = new Date(current);
          
            const startOfDateRange = new Date(1900, 0, 1);
         
            const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          
            // Format date function as 'YYYY-MM-DD'
            const formatDate = (date) => {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0'); 
              const day = String(date.getDate()).padStart(2, '0');     
              return `${year}-${month}-${day}`;
            };
          
            setMinDate(formatDate(startOfDateRange));
            setMaxDate(formatDate(endOfDateRange));
          
            console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
          }

          if (provinceId !== null) {
            setProvinceID(provinceId);
          }
          if (value3 !== null) {
            setAdmin(value3);
          }
          if (value7 !== null) {
            setCompany(value7);
          }
        } catch (e) {
          alert('Failed to fetch the input from storage');
        }
      };
    
      useEffect(() => {
        readData();
      }, []);
    
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${bearer}`
      };
    

  const handlePrinter = () => window.print(); 

  useEffect(() => {
    const fetchReference = async () => {
      setLoadingRef(true);
      try {
        const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${bearer}`,
            Accept: "application/json",
          },
        });
        if (res?.data) {
          const payload = res.data;
          const d =
            payload?.data ??
            payload?.code ??
            payload?.reference ??
            payload?.number ??
            payload?.data?.code;
          let ref = "";
          if (typeof d === "string" || typeof d === "number") {
            ref = d;
          } else if (d && typeof d === "object") {
            ref = d.code || d.reference || d.number || "";
          }
          setReference(ref ? String(ref) : "");
        }
      } catch (error) {
        console.error("Error fetching journal reference:", error);
      } finally {
        setLoadingRef(false);
      }
    };

    if (isOpen) {
      fetchReference();
    }
  }, [isOpen]);

     useEffect(() => {
    const fetchIncome = async () => {
      setLoading(true);
      try {
      const response = await axios.get(`${BASE_URL}/get-loans-receivables`,{headers});
      const inc = response.data?.data;
      setIncomeAccount(inc);

    } catch (err) {
        console.error("Error fetching accounts:", err);
        setIncomeAccount([]);
      } finally {
        setLoading(false);
      }
    };
    if (isOpen) {
      fetchIncome();
    }
  }, [isOpen]);
 
const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file); // just set state, don't upload here
    }
  };

  // 👇 This useEffect will automatically run whenever selectedImage changes
  useEffect(() => {
    if (selectedImage) {
      uploadStatement3(selectedImage); // trigger API call
    }
  }, [selectedImage]);

  useEffect(() => {
    const fetchAccounts = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/v1/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const payload = res?.data;
        // assume payload.data is the array, or payload itself
        let raw = payload?.data ?? payload;
        // If payload.data.data nested
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };

    if (isOpen) {
      fetchAccounts();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const addLine = () => {
    setRows(prev => [
      ...prev,
      { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false },
    ]);
  };

  const duplicateRow = (index) => {
    setRows(prev => {
      const newRows = [...prev];
      // create a new empty row, not a copy of the previous one
      const emptyRow = { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows(prev => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setRows(prev => {
      if (field === "showDropdown") {
        const newRows = [...prev];
        newRows[index] = { ...newRows[index], showDropdown: value };
        return newRows;
      }

      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "debit") {
        row.debit = value;
        if (value && parseFloat(value) > 0) {
          row.credit = "0";
        }
      } else if (field === "credit") {
        row.credit = value;
        if (value && parseFloat(value) > 0) {
          row.debit = "0";
        }
      } else if (field === "account") {
        // value is the selected account object (from our dropdown click)
        row.accountId = value?.id ?? "";
        // build display string of code + name
        row.accountDisplay = `${value?.gl_code ?? value?.code ?? ""} - ${value?.gl_name ?? value?.name ?? ""}`;
      } else {
        row[field] = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  const totalDebit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.debit) || 0),
    0
  );
  const totalCredit = balances.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );

  const handleSaveJournal = async () => {
    const token = localStorage.getItem("authToken");

    // Basic validation:
    if (!transactionDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Date",
        text: "Please select a transaction date.",
        confirmButtonText: "Okay",
        allowOutsideClick: false,
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) swalContainer.style.zIndex = '99999';
        },
      });
      return;
    }

    // Each row must have an account, description, and either a debit or credit (but not both)
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      const hasDebit = r.debit !== "" && !isNaN(parseFloat(r.debit)) && parseFloat(r.debit) > 0;
      const hasCredit = r.credit !== "" && !isNaN(parseFloat(r.credit)) && parseFloat(r.credit) > 0;
      if (!r.accountId) {
        Swal.fire({
          icon: "warning",
          title: "Missing Account",
          text: `Please select an account for row ${i + 1}.`,
          confirmButtonText: "Okay",
          allowOutsideClick: false,
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) swalContainer.style.zIndex = '99999';
          },
        });
        return;
      }
      if (!r.description || String(r.description).trim() === "") {
        Swal.fire({
          icon: "warning",
          title: "Missing Description",
          text: `Please add a description for row ${i + 1}.`,
          confirmButtonText: "Okay",
          allowOutsideClick: false,
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) swalContainer.style.zIndex = '99999';
          },
        });
        return;
      }
      if (!(hasDebit || hasCredit)) {
        Swal.fire("Missing Amount", `Please enter a debit or credit amount for row ${i + 1}.`, "warning");
        return;
      }
      if (hasDebit && hasCredit) {
        Swal.fire("Invalid Row", `Row ${i + 1} has both debit and credit. Only one is allowed.`, "warning");
        return;
      }
    }

    const account_id = rows.map(r => String(r.accountId));
    const direction = rows.map(r => {
      const hasDebit = r.debit !== "" && !isNaN(parseFloat(r.debit)) && parseFloat(r.debit) > 0;
      return hasDebit ? "1" : "2";
    });
    const description = rows.map(r => r.description ?? "");
    const amount = rows.map(r => {
      const hasDebit = r.debit !== "" && !isNaN(parseFloat(r.debit)) && parseFloat(r.debit) > 0;
      return hasDebit ? parseFloat(r.debit) : parseFloat(r.credit || 0);
    });

    const payload = {
      jv_number: reference,
      all_debit: totalDebit,
      all_credit: totalCredit,
      account_id,
      direction,
      transaction_date: transactionDate,
      description,
      amount,
    };

    setIsSaving(true);
    try {
      const res = await axios.post(`${BASE_URL}/v1/journal/post-entries`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: res.data.message || "Journal entry saved successfully!",
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          popup: classes.myText,
          title: classes.myTitle,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) swalContainer.style.zIndex = '99999';
        },
      });

      setRows([{ accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false }]);
      setTransactionDate("");
    } catch (error) {
      console.error("Save journal error:", error);

      let msg = "Network error";
      if (error?.response?.data) {
        const data = error.response.data;
        msg = data.message || data.error || JSON.stringify(data);
      } else if (error.message) {
        msg = error.message;
      }

      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: msg,
        customClass: {
          popup: classes.myText,
          title: classes.myTitle,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) swalContainer.style.zIndex = '99999';
        },
      });

    } finally {
      setIsSaving(false);
    }
  };

    const uploadRemittance = async () => {
      setBalanceLoading(true);
      try {
         const response = await axios.post(
        `${BASE_URL}/save-monthly-remittance`,
        {
          total_debit: parseFloat(totalDebit),
          total_credit: parseFloat(totalCredit),
          debit_gl: selectedAccount,
          uuid: balances[0]?.uuid,
          transaction_date: transactionDate



        },
        { headers }
      );
        console.log(response.data?.message, "heeee");        
        setBalances([]);
        onClose();
      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: response.data.message || "Journal entry saved successfully!",
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          popup: classes.myText,
          title: classes.myTitle,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) swalContainer.style.zIndex = '99999';
        },
      });
      
      //
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            imageUrl: crop,
            imageWidth: 48,
            imageHeight: 48,
            title: "Failed!",
            confirmButtonText: "Okay",
            text: JSON.stringify(error.response.data.message),
            customClass: {
              popup: classes.myText,
              title: classes.myTitle,
              confirmButton: classes.myDeclineButton,
            },
            allowOutsideClick: false,
            didOpen: () => {
              const swalContainer = document.querySelector('.swal2-container');
              if (swalContainer) swalContainer.style.zIndex = '99999';
            },
          });

          // Swal.fire({
          //   icon: 'error',
          //   title: 'Failed',
          //   text: JSON.stringify(error.response.data.message),
          // });
          console.log(error);
        }
      } finally {
        setBalanceLoading(false);
      }
    };
  

    const incomeOptions = incomeAccount.map((item) => ({
      label: item.gl_name,
      value: item.id,
    }));

    const handleAccountChange = (selectedOption) => {
    setSelectedAccount(selectedOption.value);
  };

    const uploadStatement3 = async () => {
      setCreateLoading(true);    
      try {    
       const formData = new FormData();
      formData.append('file', selectedImage);
      formData.append('transaction_date', transactionDate);


      const response = await axios.post(
        `${BASE_URL}/upload-monthly-remittance`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );
  
        console.log(response, "heeee");
        setBalances(response.data.data);
        // handleClose();
        // handleShow2(true);
        // Reset form fields
        // setSelectedImage("");
        // Swal.fire({
        //   icon: 'success',
        //   title: 'Successful',
        //   text: response.data.message,
        // });
        // 
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: JSON.stringify(error.response.data.message),
          });
        }
        console.error(error);
      } finally {
        setCreateLoading(false);
      }
    };
  

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <h3 className={classes.title}>Upload Monthly Remitance</h3>
        <Row>
          <Col md={8}>
            <p className={classes.subtitle}>
              Add multiple monthly remittance (Province, Description, Debit, Credit)
            </p>
          </Col>
          <Col md={4} style={{ textAlign: "right" }}>
            <p className={classes.subtitle}>
              <a
                 href={`https://account-api.patna.ng/api/v1/download-monthly-remitance?province_id=${provinceID}`} download
                
                style={{ margin: "0 0 20px 0", color: "#174384" }}
              >
                  Download Template
              </a>
            </p>
          </Col>
        </Row>

        <Row style={{ paddingTop: 20, paddingBottom: 15, fontSize: "12px" }}>
          <Col md={3}>
              <label>Journal Reference</label>
              <div className={classes.refContainer}>
                {loadingRef ? (
                  <div className={classes.spinnerWrapper}>
                    <Spinner animation="border" size="sm" />
                  </div>
                ) : (
                <Form.Control
                  type="text"
                  value={reference}
                  readOnly
                  placeholder="Fetching reference..."
                  style={{ width: "100%", fontSize: "12px" }}
                />
                )}
              </div>
          </Col>
          <Col md={3}>
              <label>Transaction Date</label>
             <Form.Control
                type="date"
                value={transactionDate}
                onChange={e => setTransactionDate(e.target.value)}
                required
                style={{ width: "100%", fontSize: "12px" }}
                min={minDate}
                max={maxDate}
              />
          </Col>
          <Col md={3}>
            <label>Select Account</label>
            <Select
              options={incomeOptions}
              placeholder="Select Account"
              onChange={handleAccountChange}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                control: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  minHeight: "32px", 
                  height: "32px", 
                  padding: "0 4px", 
                  borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                }),

                valueContainer: (base) => ({
                  ...base,
                  padding: "0 6px", // reduce vertical padding inside the box
                  height: "28px",
                }),

                indicatorsContainer: (base) => ({
                  ...base,
                  height: "28px",
                }),

                option: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                  color: "black",
                }),

                menuList: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  overflowY: "auto",
                }),
              }}
            />
          </Col>
          <Col md={3}>
              <label>Upload Excel</label>
             <Form.Control
                type="file"
                // ref={fileInputRef}
                style={{ fontSize: "12px" }}
                placeholder="Choose file"
                accept=".xlsx"
                onChange={handleImageChange}
                // onBlur={uploadStatement3}
                //   onChange={(event) => {
                //   const file = event.target.files[0];
                //   if (file) {
                //     handleImageChange(event);
                //     uploadStatement3(file); 
                //     event.target.value = "";
                //   }
                // }}
              />
          </Col>
        </Row>
        <div className={classes.mainTable} style={{ paddingBottom: 30 }}>
          <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto', }}>
            <table className="table display bg-white m-0 card-table">
              <thead style={{ whiteSpace: "nowrap", textAlign: "left", }}>
                <tr style={{ padding: "2px 10px", margin: "2px 10px", fontSize: 13 }}>
                  <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "10%", padding: "7px 10px", margin: "7px 10px"}}>S/N</th>
                  <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px"}}>Province Name</th>
                  <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, width: "30%", padding: "7px 10px", margin: "7px 10px"}}>Description</th>
                  {/* <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px"}}>Debit</th> */}
                  <th style={{ position: 'sticky', top: 0, background: '#f5f7fb', zIndex: 2, textAlign: "right", width: "15%", padding: "7px 10px", margin: "7px 10px"}}>Credit</th>
                </tr>
              </thead>
              <tbody>
              {balances.map((item, index) => (
              <tr key={index} style={{ padding: "2px 10px", margin: "2px 10px", fontSize: 13 }}>
                <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                  {index + 1}
                </td>
                <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                  {item.customer_name}
                </td>
                <td style={{ padding: "2px 10px", margin: "2px 10px" }}>
                  {item.description}
                </td>
                {/* <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>0.00</td> */}
                <td style={{ textAlign: "right", paddingRight: 10, padding: "2px 10px", margin: "2px 10px" }}>{parseFloat(item.amount).toLocaleString('en-US', {
                  minimumIntegerDigits: 1,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                </td>
              </tr>
              ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* <div style={{ marginTop: "15px" }} />
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Closing Balance:</Form.Label>
                <Form.Control
                  type="text"
                  value={closingBalance2}
                  name="total"
                  disabled
                  style={{ textAlign: 'right' }}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
            </Col>
            <Col md={6}>
              <Row>
                <Col md={6}>
                <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                  <Form.Label>Total Credit:</Form.Label>
                  <Form.Control
                    type="text"
                    name="total"
                    value={totalAmountCredit2}
                    disabled
                    style={{ textAlign: 'right' }}
                  />
                </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                  <Form.Label>Total Debit:</Form.Label>
                  <Form.Control
                    type="text"
                    name="total"
                    value={totalAmountDebit2}
                    disabled
                    style={{ textAlign: 'right' }}
                  />
                </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
        </div> */}

        <Row>
          <Col md={6} xs={6}>
            {/* <Button className={classes.submitBtn} onClick={addLine} disabled>
              + Add Line
            </Button> */}
          </Col>
          <Col md={3} xs={3}>
            <div className={classes.totalBox}>              
              <span>Total Debit</span>
              <strong>{totalCredit.toFixed(2)}</strong>
            </div>
          </Col>
          <Col md={3} xs={3}>
            <div className={classes.totalBox}>              
              <span>Total Credit</span>
              <strong>
                {parseFloat(totalCredit).toLocaleString('en-US', {
                  minimumIntegerDigits: 1,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}</strong>
            </div>
          </Col>
        </Row>
        <hr />
        <div className={classes.footerButtons}>
          <button
            className={classes.resetBtn}
            onClick={onClose}
          >
            Close
          </button>
          <button className={classes.printBtn} onClick={handlePrinter}>Print</button>
          <Button
            className={classes.submitBtn}
            onClick={() => uploadRemittance()}
            disabled={balanceLoading}
          >
            {balanceLoading ? (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                <Spinner animation="border" size="sm" />
                Saving...
              </span>
            ) : (
              "Submit Remittance"
            )}
          </Button>
        </div>

        <button className={classes.closeBtn} onClick={onClose}>
          ×
        </button>
      </div>
      {createLoading && (
              <div className={classes.overlay}>
                <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
              </div>
            )}
      
    </div>
  );
}

export default JournalModal;
